import React from 'react';
import { motion } from 'framer-motion';
import cscResistant from '../img/CSC résistante.png';

const MissionSection = () => {
  return (
    <section id="mission" className="py-20 md:py-32 relative bg-ninsun-surface border-y border-gray-200">
      <div className="container mx-auto px-6">
        
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-6 tracking-tight">Cancer Stem Cells</h2>
          <p className="text-xl md:text-2xl text-ninsun-muted leading-relaxed">
            Support optimal treatment decision-making by providing actionable insights into cancer stem cells burden within the tumor microenvironment, a key driver of resistance to immunotherapy.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-3xl font-display font-bold text-ninsun-text tracking-tight">
              Cancer Stem Cells at the root of resistance to immunotherapy
            </h3>
            <p className="text-ninsun-muted leading-relaxed">
              Despite the remarkable advances achieved with cancer immunotherapy, a substantial proportion of patients fail to obtain durable clinical responses. Growing evidence suggests that Cancer Stem Cells (CSCs) may play a critical role in this challenge.
            </p>
            <p className="text-ninsun-muted leading-relaxed">
              CSCs constitute a rare but highly aggressive subpopulation of tumor cells characterized by self-renewal capacity, tumor-initiating potential, and remarkable resistance to therapy. Increasing studies indicate that CSCs can evade immune surveillance through multiple mechanisms, including reduced antigen presentation, enhanced expression of immune checkpoint molecules, secretion of immunosuppressive factors, and modulation of the tumor microenvironment.
            </p>
            <p className="text-ninsun-muted leading-relaxed">
              By escaping immune-mediated elimination, CSCs may persist following treatment and contribute to disease progression, metastasis, and tumor recurrence. Their presence has been associated with poor prognosis and reduced responsiveness to immunotherapy in several cancer types.
            </p>
            <p className="text-ninsun-text font-bold leading-relaxed">
              As a result, CSCs are increasingly recognized as both a promising biomarker for predicting treatment response and therapeutic target for more effective and personalized therapeutic strategies.
            </p>
            <p className="text-ninsun-muted leading-relaxed">
              But despite all this growing evidence, current patient stratification still does not include cancer stem cells quantification in tumor microenvironment.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="self-start"
          >
            <img
              src={cscResistant}
              alt="Cancer Stem Cell Resistance Mechanism"
              className="rounded-2xl shadow-lg w-full h-auto max-h-[420px] object-contain mx-auto border border-gray-200"
            />
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default MissionSection;